// Vendor Libs
import React from "react";

export const RouteContext = React.createContext({
  location: undefined,
  push: undefined,
  routerParams: undefined
});
